<template>
    <div class="notifications d-flex align-self-center">
        <ideo-dropdown
            ref="notificationDropdown"
            variant="light"
            class="notifications-dropdown"
            toggle-class="btn-dropdown-white ms-1"
            right
            no-caret
            :title="$t('[[[Powiadomienia]]]')"
        >
            <template #button-content>
                <i class="fa-solid fa-bell"></i>
                <span class="badge badge-success ms-auto" v-if="total > 0">{{
                    badgeText(total)
                }}</span>
            </template>
            <ideo-dropdown-item>
                <div
                    class="text-center p-2"
                    v-if="total == 0"
                    @click.prevent="handleClickNotification"
                >
                    {{ $t("[[[Brak nowych powiadomień.]]]") }}
                </div>
                <div v-else class="notifications-scroll-container">
                    <div
                        class="notifications-dropdown-element"
                        v-for="message in messagesList"
                        :key="message.uid"
                        @click.prevent="
                            () => {
                                chatRead(message);
                                redirect(routeTo(message.payload.data));
                                handleClickToggleNotification();
                            }
                        "
                    >
                        <div class="d-flex align-items-center">
                            <div class="me-3">
                                <i
                                    class="icon fal fa-check-circle text-success"
                                    v-if="message.payload.level == 'success'"
                                ></i>
                                <i
                                    class="icon fal fa-info-circle text-info"
                                    v-if="message.payload.level == 'info'"
                                ></i>
                                <i
                                    class="icon fal fa-exclamation-circle text-warning"
                                    v-if="message.payload.level == 'warning'"
                                ></i>
                                <i
                                    class="icon fal fa-exclamation-triangle text-danger"
                                    v-if="message.payload.level == 'error'"
                                ></i>
                            </div>
                            <div class="flex-fill">
                                <div
                                    :class="[
                                        'text-dark',
                                        `notification-meta-${message.payload.data.meta?.toLowerCase()}`,
                                    ]"
                                    v-html="message.payload.data.message"
                                ></div>
                                <div class="text-muted small">
                                    {{
                                        $filters.datetime(
                                            message.dateCreatedUtc
                                        )
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    v-if="total != 0"
                    class="dropdown-item text-center small border-top pt-2 pb-0 d-flex gap-1 flex-column justify-content-center"
                    @click="toggle = false"
                >
                    <router-link
                        class="py-2"
                        :to="{ name: 'core-account-notifications' }"
                        @click="handleClickToggleNotification"
                    >
                        {{ $t("[[[Zobacz wszystkie]]]") }}
                    </router-link>
                    <a href="#" class="py-1" @click.prevent="notificationsAllRead">{{
                        $t("[[[Oznacz wszystkie jako przeczytane]]]")
                    }}</a>
                </div>
            </ideo-dropdown-item>
        </ideo-dropdown>
        <ideo-dropdown
            ref="messagesDropdown"
            variant="light"
            class="notifications-dropdown"
            toggle-class="btn-dropdown-white ms-1"
            right
            no-caret
            :title="$t('[[[Wiadomości]]]')"
        >
            <template #button-content>
                <i class="fa-solid fa-message"></i>
                <span
                    class="badge badge-success ms-auto"
                    v-if="chatTotal > 0"
                >{{ badgeText(chatTotal) }}</span>
            </template>
            <ideo-dropdown-item>
                <div
                    class="text-center p-2"
                    v-if="chatTotal == 0"
                    @click.prevent="handleClickMessage"
                >
                    {{ $t("[[[Brak nowych wiadomości.]]]") }}
                </div>
                <div v-else>
                    <div
                        class="notifications-dropdown-element"
                        v-for="message in chatMessagesList"
                        :key="message.uid"
                        @click.prevent="
                            () => {
                                chatRead(message);
                                redirect(routeTo(message.payload.data));
                                handleClickToggleMessages();
                            }
                        "
                    >
                        <div class="d-flex align-items-center">
                            <div class="me-3">
                                <i
                                    class="icon fal fa-check-circle text-success"
                                    v-if="message.payload.level == 'success'"
                                ></i>
                                <i
                                    class="icon fal fa-info-circle text-info"
                                    v-if="message.payload.level == 'info'"
                                ></i>
                                <i
                                    class="icon fal fa-exclamation-circle text-warning"
                                    v-if="message.payload.level == 'warning'"
                                ></i>
                                <i
                                    class="icon fal fa-exclamation-triangle text-danger"
                                    v-if="message.payload.level == 'error'"
                                ></i>
                            </div>
                            <div class="flex-fill">
                                <div
                                    class="text-dark"
                                    v-html="message.payload.data.message"
                                ></div>
                                <div class="text-muted small">
                                    {{
                                        $filters.datetime(
                                            message.dateCreatedUtc
                                        )
                                    }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="dropdown-item text-center small border-top pt-2 pb-0 mt-3"
                        @click="toggle = false"
                    >
                        <router-link to="" @click.prevent="chatAllRead()">
                            {{ $t("[[[Oznacz widoczne jako przeczytane]]]") }}
                        </router-link>
                    </div>
                </div>
            </ideo-dropdown-item>
        </ideo-dropdown>
    </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import {
    FilterModel,
    MARK_AS_READ_CHATS,
    MessageModel,
} from "@/modules/core/common/services/NotificationsService";
import { Pagination } from "@/helpers/Interfaces";
import { Invoke, Listen } from "@/plugins/signalr";
import Pager from "@/helpers/Pager";
import {
    NotificationNavigation,
    NotificationNavigationType,
} from "@/helpers/NotificationNavigation";
import { RouteLocationRaw } from "vue-router";
import { Watch, Ref } from "@/helpers/Decorators";
import setAppTitle, {
    AppTitleEnum,
} from "@/modules/renter/common/helpers/appTitle";
import NotificationsService from "@/modules/core/common/services/NotificationsService";
import IdeoDropdown from "@/components/bootstrap/dropdown/IdeoDropdown.vue";

@Options({})
export default class Notifications extends Vue
{
    @Ref()
    public notificationDropdown: () => IdeoDropdown;

    @Ref()
    public messagesDropdown: () => IdeoDropdown;

    public timeout: any = null;
    public messages: MessageModel[] = [];
    public chatMessages: MessageModel[] = [];
    public total: number = 0;
    public chatTotal: number = 0;
    public toggle: boolean = false;

    public get messagesList(): MessageModel[]
    {
        return this.messages.slice(0, 10);
    }

    public get chatMessagesList(): MessageModel[]
    {
        return this.chatMessages.slice(0, 10);
    }

    public async created(): Promise<void>
    {
        this.loadData();
    }

    public markAsReadFromRoomList(publicId: string): void
    {
        if (publicId)
        {
            const previousMessagesCount = this.chatMessages.length;

            this.chatMessages = this.chatMessages.filter((message) =>
            {
                return message.payload.data.publicId !== publicId;
            });

            this.chatTotal -= (previousMessagesCount - this.chatMessages.length);
        }
    }

    public mounted(): void
    {
        window.addEventListener("click", this.click);
        this.$events.$on(MARK_AS_READ_CHATS, this.markAsReadFromRoomList);

        window.addEventListener('focus', this.loadData);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    public unmounted(): void
    {
        window.removeEventListener("click", this.click);
        this.$events.$off(MARK_AS_READ_CHATS, this.markAsReadFromRoomList);

        window.removeEventListener('focus', this.loadData);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    public routeTo(navigation: NotificationNavigationType): RouteLocationRaw
    {
        return NotificationNavigation(navigation);
    }

    public badgeText(count: number): string
    {
        return count > 99 ? '99+' : String(count);
    }

    public async loadData(): Promise<boolean>
    {
        try
        {
            const result = await this.getNotifications(
                { isRead: false },
                new Pager(1, 10, "Id", "DESC").data(),
                this.preferedLanguage
            );

            this.messages = result.items;
            this.total = result.totalRows;

            const chatResult = await this.getChatNotifications(
                { isRead: false },
                new Pager(1, 10, "Id", "DESC").data(),
                this.preferedLanguage
            );

            this.chatMessages = chatResult.items;
            this.chatTotal = chatResult.totalRows;
        }
        catch (ex)
        {
            //#150012
            // this.handleException(ex, {
            //     0: (ex: any) =>
            //         this.$alert.danger(
            //             this.$t("[[[Nie udało się pobrać powiadomień.]]]")
            //         ),
            // });

            return false;
        }

        return true;
    }

    public async notificationsAllRead(): Promise<void>
    {
        try
        {
            await NotificationsService.markAllNotificationsAsRead();
            await this.loadData();
        }
        catch (ex)
        {
            this.$log.debug(ex);
        }
    }

    public async read(message: MessageModel): Promise<void>
    {
        if (!message.isRead)
        {
            message.isRead = true;

            await this.markAsRead(message.uid);

            if (this.timeout) clearTimeout(this.timeout);

            this.timeout = setTimeout(() => this.loadData(), 1000);
        }
    }

    public async chatRead(message: MessageModel): Promise<void>
    {
        if (!message.isRead)
        {
            message.isRead = true;

            await this.markChatNotificationAsRead(message.uid);

            if (this.timeout) clearTimeout(this.timeout);

            this.timeout = setTimeout(() => this.loadData(), 1000);
        }
    }

    public async chatAllRead(): Promise<void>
    {
        for (let index = 0; index < this.chatMessages.length; index++)
        {
            const message = this.chatMessages[index];

            message.isRead = true;

            await this.markChatNotificationAsRead(message.uid);
        }

        if (this.timeout) clearTimeout(this.timeout);

        this.timeout = setTimeout(() => this.loadData(), 1000);
    }

    @Invoke("basicNotifications")
    public getNotifications: (
        filter: FilterModel,
        pager: any,
        lang: string
    ) => Promise<Pagination<MessageModel>>;

    @Invoke("basicNotifications")
    public markAsRead: (uid: string) => Promise<void>;

    @Invoke("chat")
    public getChatNotifications: (
        filter: FilterModel,
        pager: any,
        lang: string
    ) => Promise<Pagination<MessageModel>>;

    @Invoke("chat")
    public markChatNotificationAsRead: (uid: string) => Promise<void>;

    @Listen("notifications")
    public async messageReceived(payload: any): Promise<void>
    {
        this.loadData();

        if (payload.data.isChatNotification)
            setAppTitle(AppTitleEnum.NewMessage, true);

        this.$alert[payload.level](payload.data.message, {
            onClick: () =>
                payload.data.navigation
                    ? this.redirect(this.routeTo(payload.data))
                    : null,
        });
    }

    public forceDownload(url: string, fileName: string): void
    {
        location.href = this.$filters.baseurl(`${url}?dl`);
    }

    public click(): void
    {
        setAppTitle(AppTitleEnum.Default);
        this.toggle = false;
    }

    private onVisibilityChange = (): void =>
    {
        if (document.visibilityState === 'visible')
            this.loadData();
    };

    @Watch("$store.state.renter.chat.removeNotification")
    private async onRemoveNotification(dataPublicId: string): Promise<void>
    {
        if (dataPublicId)
        {
            const notification: MessageModel = this.chatMessagesList.find(
                ({ payload: { data } }: any) => data.publicId === dataPublicId
            );

            if (notification) this.chatRead(notification);

            this.$store.state.renter.chat.removeNotification = null;
        }
    }

    public get preferedLanguage(): string
    {
        return this.$store.state.auth.identity.preferedLanguage;
    }

    public handleClickNotification(): void
    {
        this.$router.push({ name: "core-account-notifications" });
        this.handleClickToggleNotification();
    }

    public handleClickToggleNotification(): void
    {
        this.notificationDropdown().hide();
    }

    public handleClickMessage(): void
    {
        this.$router.push({ name: "chat-myrooms" });
        this.handleClickToggleMessages();
    }

    public handleClickToggleMessages(): void
    {
        this.messagesDropdown().hide();
    }
}
</script>

<style lang="scss" scoped>

    .notifications {
        .dropdown-item {
            padding: 0 !important;

            &:hover {
                background-color: unset !important;
            }
        }

        &-dropdown-element {
            padding: 0.375rem 1.25rem;

            &:hover {
                color: var(--cui-dropdown-link-hover-color);
                background-color: var(--cui-dropdown-link-hover-bg);
            }
        }
    }

</style>

<style lang="scss">
.notifications-dropdown .dropdown-menu {
    margin-top: 10px !important;
}

.notifications {
    .dropdown-menu {
        width: 300px;
    }
    .dropdown-item {
        white-space: normal;
    }
}

.notification-meta {
    &-bold {
        font-weight: bold;
    }
}

@include media-breakpoint-down(sm) {
    // badge overlays the icon instead of widening the button, so the header never pushes the profile icon off screen
    .notifications {
        flex-shrink: 0;

        .btn-dropdown-white {
            position: relative;
            padding-left: .5rem;
            padding-right: .5rem;

            .badge {
                position: absolute;
                top: 2px;
                right: -2px;
                margin: 0 !important;
                padding: .15rem .3rem;
                font-size: .6rem;
                line-height: 1;
            }
        }
    }
}

@include media-breakpoint-only(xs) {
    .dropdown-menu-right {
        right: -64px;
    }
    .dropdown-menu.arrow.dropdown-menu-right:before {
        right: 85px;
    }
    .dropdown-menu.arrow.dropdown-menu-right:after {
        right: 86px;
    }
}

.notifications-scroll-container {
    overflow: auto;
    max-height: 75vh;
}


</style>
